import { CommonModule } from '@angular/common';
import { Component, effect, inject, ViewEncapsulation } from '@angular/core';
import { RegistrationStep } from '@core/models/common.interface';
import { PersonalDetails } from './_components/personal-details/personal-details';
import { RegistrationSuccess } from './_components/registration-success/registration-success';
import { TermsAndConditions } from './_components/terms-and-conditions/terms-and-conditions';
import { RegistrationStore } from './store/registration.store';

@Component({
  selector: 'app-registration',
  imports: [CommonModule, TermsAndConditions, PersonalDetails, RegistrationSuccess],
  templateUrl: './registration.html',
  styleUrl: './registration.scss',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
})
export class Registration {
  step: RegistrationStep = RegistrationStep.termsAndConditions;
  RegistrationStep = RegistrationStep;
  store = inject(RegistrationStore);

  constructor() {
    effect(() => {
      const success = this.store.registered();

      if (success) {
        this.step = RegistrationStep.registrationSuccess;
      }
    });
  }
}
